import { render, staticRenderFns } from "./ModalPontoRessuprimentoProduto.vue?vue&type=template&id=27f98221"
import script from "./ModalPontoRessuprimentoProduto.vue?vue&type=script&lang=js"
export * from "./ModalPontoRessuprimentoProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports